import type { HeadersFunction, MetaFunction } from "@remix-run/node";
import { CacheRevalidate2Weeks } from "@tknf/node-header-helpers";
import clsx from "clsx";
import { Link } from "@remix-run/react";
import { createOGP } from "@/utilities/ogp";
import common from "@/data/common.json";
import { PageContainer } from "@/components/PageContainer";
import { ArticleLayout } from "@/components/ArticleLayout";
import { DisplayText } from "@/components/DisplayText";

export const meta: MetaFunction = () => {
  return createOGP({ path: `${common.meta.url}/contact`, pageName: "お問い合わせ" });
};

export const headers: HeadersFunction = () => {
  return {
    "Cache-Control": CacheRevalidate2Weeks(),
  };
};

export default function ContactIndex() {
  return (
    <PageContainer>
      <ArticleLayout
        size="small"
        paths={[
          { name: "ホーム", url: "/" },
          { name: "お問い合わせ", url: "/contact" },
        ]}
      >
        <div className={clsx("flex", "flex-col", "space-y-8")}>
          <DisplayText element="h1" size="extraLarge">
            お問い合わせ
          </DisplayText>
          <div className={clsx("text-lg", "leading-normal", "mb-4")}>
            <p>専用利用の仮申込、もしくはお問い合わせをします。</p>
            <p>ご希望のメニューをお選びください。</p>
          </div>

          <div className={clsx("flex", "items-center", "space-x-4")}>
            <Link to="/contact/reservation" className="button button--primary">
              <span className="button__backdrop" />
              <span className="button__content">専用利用の仮申込</span>
            </Link>
            <Link to="/contact/reservation" className="button button--primary">
              <span className="button__backdrop" />
              <span className="button__content">施設へのお問い合わせ</span>
            </Link>
          </div>
        </div>
      </ArticleLayout>
    </PageContainer>
  );
}
